// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import type { HeadFC, PageProps } from 'gatsby'
import TitlePage from '../components/home/heroSection/TitlePage'
import { SEO } from '../components/seo'
import Offerings from '../components/home/offerings/Offerings'
import GaudiAiSection from '../components/home/gaudiAiSection/GaudiAiSection'
import ResourceTemplate from '../components/home/resourceAIandRD/ResourceTemplate'
import Intersticial from '../components/global/intersticialCustom/Intersticial'
import Intersticials from '../components/global/intersticialCustom/Intersticials.types'
import PageLayout from '../components/global/pageLayout/PageLayout'
import { productOfferings } from '../components/global/offerings/Offerings.types'
import OfferingsGlobal from '../components/global/offerings/Offerings'

const IndexPage: React.FC<PageProps> = () => {
  return (
    <PageLayout>
      <TitlePage />
      <Offerings />
      <OfferingsGlobal {...productOfferings.availableCompute} />
      <GaudiAiSection />
      <ResourceTemplate page="rd" />
      <Intersticial {...Intersticials.bePartOfOurProgram} />
      <ResourceTemplate page="ai" />
      <Intersticial {...Intersticials.getStarted} />
    </PageLayout>
  )
}

export default IndexPage

export const Head: HeadFC = () => (
  <SEO
    title="Intel® Tiber™ AI Cloud"
    description="Validate your AI concepts. Intel® Tiber™ AI Cloud offers powerful GPU & AI compute for rapid experimentation and model iteration. Build, test, and innovate your AI ideas."
  />
)
